import { DefaultRow } from "@pdf/helpers/default-row/default-row";
import { jsPDF } from "jspdf";

export class CableRouteRow extends DefaultRow {
  readonly number: string[];
  readonly displayName: string[];
  readonly name: string[];
  readonly constructionKit: string[];
  readonly scalingLength: string[];
  readonly notes: string[];

  public constructor(
    pdf: jsPDF,
    number: string[],
    displayName: string[],
    name: string[],
    constructionKit: string[],
    scalingLength: string[],
    notes: string[],
  ) {
    super();
    this.number = number;
    this.displayName = displayName;
    this.name = name;
    this.constructionKit = constructionKit;
    this.scalingLength = scalingLength;
    this.notes = notes;
    this._textHeight = this.calculateRowTextHeight(pdf);
    this._rowHeight = this.calculateRowHeight(this.textHeight);
  }

  public calculateRowTextHeight(pdf: jsPDF) {
    return Math.max(
      ...[
        this.calculateCellTextHeight(pdf, this.number),
        this.calculateCellTextHeight(pdf, this.displayName),
        this.calculateCellTextHeight(pdf, this.name),
        this.calculateCellTextHeight(pdf, this.constructionKit),
        this.calculateCellTextHeight(pdf, this.scalingLength),
        this.calculateCellTextHeight(pdf, this.notes),
      ],
    );
  }
}
